import { render, staticRenderFns } from "./QRIndex.vue?vue&type=template&id=7ba54d21&scoped=true"
import script from "./QRIndex.vue?vue&type=script&lang=js"
export * from "./QRIndex.vue?vue&type=script&lang=js"
import style0 from "./QRIndex.vue?vue&type=style&index=0&id=7ba54d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba54d21",
  null
  
)

export default component.exports